// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Dlqi","fileBtn":"File_fileBtn__2tuCe","closeBtn":"File_closeBtn__bKA_O","fileSelected":"File_fileSelected__1IxOb","disabled":"File_disabled__3MZ-g"};